import {
  IApiBusinessProfileProto,
  IKensuCalendarEventProto,
  KensuCalendarEventProto,
  space
} from "../../../../provider_api";
import {CalendarEventType} from "./EventModal";
import IPractitionerProto = space.kenko.proto.IPractitionerProto;
import IServiceProto = space.kenko.proto.IServiceProto;
import DayOfWeekProto = space.kenko.proto.DayOfWeekProto;

export const findPractitioner = (practitioners: IPractitionerProto[] | null | undefined,
                                 practitionerId: string | null | undefined): IPractitionerProto | null => {

  if (!practitioners) {
    return null;
  }

  if (!practitionerId) {
    return null;
  }

  const index = findPractitionerIndex(practitioners, practitionerId);
  return index < 0 ? null : practitioners[index];
}

export const findPractitionerIndex = (providers: IPractitionerProto[] | null | undefined,
                                      practitionerId: string | null | undefined): number => {

  if (!practitionerId || !providers?.length) {
    return -1;
  }

  for (let i = 0; i < providers.length; i++) {
    let provider = providers[i];
    if (provider.practitionerId == practitionerId) {
      return i;
    }
  }

  return -1;
}

// Returns all the services this provider offers, and at which price.
export const getServicesForPractitioner = (
    services: IServiceProto[] | null | undefined,
    practitionerId: string | null | undefined): IServiceProto[] => {

  if (!services || !practitionerId) {
    return [];
  }

  return services.filter(service => service.practitionerId && service.practitionerId.indexOf(practitionerId) >= 0);
}

export const findService = (profile: IApiBusinessProfileProto | undefined | null, sku: string | undefined | null) => {
  if (!profile?.practice?.services || !sku) {
    return null;
  }

  for (let i = 0; i < profile.practice.services.length; i++) {
    const service = profile.practice.services[i];
    if (service.sku == sku) {
      return service;
    }
  }

  return null;
}

export const findClassTemplate = (profile: IApiBusinessProfileProto | undefined | null, classTemplateId: string | undefined | null) => {
  if (!profile?.studio?.classTemplates || !classTemplateId) {
    return null;
  }

  for (let i = 0; i < profile.studio.classTemplates.length; i++) {
    const classTemplate = profile.studio.classTemplates[i];
    if (classTemplate.classTemplateId == classTemplateId) {
      return classTemplate;
    }
  }

  return null;
}

export const findLocation = (profile: IApiBusinessProfileProto | undefined | null, locationId: string | undefined | null) => {
  if (!profile?.locations || !locationId) {
    return null;
  }

  for (let i = 0; i < profile.locations.length; i++) {
    if (profile.locations[i].locationId == locationId) {
      return profile.locations[i];
    }
  }

  return null;
}

export const findPriceCategory = (profile: IApiBusinessProfileProto | undefined | null, id: string | undefined | null) => {
  if (!profile?.pricing?.priceCategories || !id) {
    return null;
  }

  for (let i = 0; i < profile.pricing.priceCategories.length; i++) {
    if (profile.pricing.priceCategories[i].categoryId == id) {
      return profile.pricing.priceCategories[i];
    }
  }

  return null;
}

export const findClassPack = (profile: IApiBusinessProfileProto | undefined | null, id: string | undefined | null) => {
  if (!profile?.pricing?.packages || !id) {
    return null;
  }

  for (let i = 0; i < profile.pricing.packages.length; i++) {
    if (profile.pricing.packages[i].id == id) {
      return profile.pricing.packages[i];
    }
  }

  return null;
}

export const spanToMinutes = (startMs: number, endMs: number): number => {
  return (endMs - startMs) / 1000 / 60;
}

export const getEventType = (instance: IKensuCalendarEventProto): CalendarEventType | undefined => {
  return (instance as KensuCalendarEventProto).Type;
}

export  const getColor = (i: number) => {
  switch (i % 10) {
    case 0:
      return 'var(--orange)';
    case 1:
      return 'var(--green)';
    case 2:
      return 'var(--mustard)';
    case 3:
      return 'var(--beige-hover)';
    case 4:
      return 'var(--red)';
    case 5:
      return 'var(--black)';
    case 6:
      return 'var(--lightgreen)';
    case 7:
      return 'var(--gray)';
    case 8:
      return 'var(--mediumgreen)';
    case 9:
      return 'var(--beige)';
    default:
      return '#124567'
  }
}
